import { ROUTER_PATH } from "@config/router";
import type { JsonRenderSchemaAssetType } from "./type";

/**
 * Detail pathname for JsonRender assets (matches `AssetRecommendationList` href rules).
 */
export function buildJsonRenderAssetDetailPath(
  type: JsonRenderSchemaAssetType,
  symbol: string,
  id?: string,
): string {
  if (type === "crypto") {
    const slug = typeof id === "string" && id.length > 0 ? id : symbol;
    return `${ROUTER_PATH.CRYPTO_TOKEN}/${encodeURIComponent(slug)}`;
  }
  return `${ROUTER_PATH.STOCK_DETAIL}/${encodeURIComponent(symbol)}`;
}
